import { Grid, Paper, Typography } from '@mui/material';
import { BarChart, PieChart } from '@mui/x-charts-pro';
import React, { useEffect, useState } from 'react'
import { getProfile } from '../../reducer/profileSlice';
import { useSelector } from 'react-redux';
import { getIAAM } from '../../reducer/iaamSlice';
import { getWeekOfYear } from '../../reducer/weekOfYearSlice';



// let activityData = [{
//     count: 0,
//     type: "ประชุม EOC",
// }, {
//     count: 0,
//     type: "ประชุมคณะกรรมการโรคติดต่อจังหวัด",
// }, {
//     count: 0,
//     type: "ประชุมอื่นๆ",
// }, {
//     count: 0,
//     type: "สอบสวนหาแหล่งแพร่เชื้อ",
// }, {
//     count: 0,
//     type: "ค้นหาผู้ป่วยเพิ่มเติม",
// }, {
//     count: 0,
//     type: "สำรวจและกำจัดลูกน้ำยุงลาย",
// }, {
//     count: 0,
//     type: "พ่นสารเคมีกำจัดยุงตัวโตเต็มวัย",
// }, {
//     count: 0,
//     type: "สื่อสารความเสี่ยง/รณรงค์",
// }, {
//     count: 0,
//     type: "ประชาคมหมู่บ้าน/ชุมชน",
// }, {
//     count: 0,
//     type: "การวินิจฉัยรักษาโรคไข้เลือดออก เช่น ประชุม Dead",
// }, {
//     count: 0,
//     type: "case conference, อบรมแพทย์ เป็นต้น",
// }]

let eocData;
function DashboardEocSummary(props) {
    const iaam = useSelector(getIAAM);
    const profile = useSelector(getProfile);
    const woy = useSelector(getWeekOfYear);
    const [loadFinish, setLoadFinish] = useState(false);
    const [openEOC, setOpenEOC] = useState(false);
    const [qualifyEOC, setQualifyEOC] = useState(false);
    const [areaName, setAreaName] = useState("");
    const [activityList, setActivityList] = useState([]);
    // const [eocData, setEocData] = useState();

    useEffect(() => {
        const callQualifyData = async () => {
            iaam.getAccessToken(async (err, access_token) => {
                if(!err){
                    let areaLevel = "amphur";
                    if (profile.org_level === "02") {
                        areaLevel = 'region';
                    } else if (profile.org_level === "03") {
                        areaLevel = "province";
                    }
                    let options = {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json', 
                            'Authorization': `bearer ${access_token}`
                        }
                    }
                    const response = await fetch(`${process.env.REACT_APP_API_URL_SECURE}/d506-eoc/${areaLevel}?week=${woy.week}&year=${woy.year}&disease_class=1`, options);
                    const json = await response.json();
                    
                    let attr = "area_code";
                    if (profile.org_level === "02") {
                        attr = "health_region_code";
                    }
                    let qualifyData = json[profile[attr]];
                    setQualifyEOC(qualifyData.eoc_status);
                }
                else{
                    iaam.login()
                }
            })
        }
        const callEocActive = async () => {
            // const responseQualify = await fetch(`${process.env.REACT_APP_API_URL}/my_eoc/get_eoc/${profile?.org_level}?${param}`);
            if (profile.org_level !== '01') {
                await callQualifyData();
            }

            let data;
            if (eocData === undefined) {
                let param = "";
                if (profile?.org_level === "02") {
                    param = `org_id=${profile?.org_id}`;
                } else {
                    param = `area_code=${profile?.area_code}`;
                }
                const response = await fetch(`${process.env.REACT_APP_API_URL}/my_eoc/get_eoc/${profile?.org_level}?${param}`);
                const dataJson = await response.json();
                // data = {...dataJson};
                eocData = {...dataJson};
            }
            data = {...eocData};
            // let eocList = [...data.history_eoc, ...data.active_eoc]
            // for (let index = eocList.length - 1; index >= 0; index--) {
            //     const element = eocList[index];
            //     if () {

            //     }
            //     // console.log(element);
            // }
            if (data.active_eoc.length > 0) {
                setOpenEOC(true);
                let eocData = data.active_eoc[0];
                let eoc_id = eocData.eoc_id;
                const responseActivity = await fetch(`${process.env.REACT_APP_API_URL}/my_eoc/get_activity/${eoc_id}`);
                const dataActivity = await responseActivity.json();
                let count = {};
                for (let index = 0; index < dataActivity.length; index++) {
                    const element = dataActivity[index];
                    const activityList = element.activity;
                    for (let j = 0; j < activityList.length; j++) {
                        const activityName = activityList[j];
                        if (count[activityName] === undefined) {
                            count[activityName] = 1;
                        } else {
                            count[activityName]++;
                        }
                    }
                }

                const responseActivityName = await fetch(`${process.env.REACT_APP_API_URL}/config/my_activity_config`);
                const dataActivityName = await responseActivityName.json();
                const config = dataActivityName.config;
                let activityListTmp = [];
                for (let index = 0; index < config.length; index++) {
                    const element = config[index];
                    if (count[element] === undefined) {
                        activityListTmp.push({
                            count: 0,
                            type: element
                        })
                    } else {
                        activityListTmp.push({
                            count: count[element],
                            type: element
                        })
                    }
                }
                setActivityList(activityListTmp);
            } else {
                setOpenEOC(false);
            }
            setLoadFinish(true);
        }
        
        // console.log(profile);
        // console.log(woy);
        if (profile !== undefined && woy !== undefined) {
            let area_name = `อำเภอ${profile.amphur_name}`;
            if (profile.org_level === "01") {
                area_name = "ประเทศไทย";
            } else if (profile.org_level === "02") {
                area_name = profile.org_name;
            } else if (profile.org_level === "03") {
                area_name = `จังหวัด${profile.province_name}`;
            }
            setAreaName(area_name)
            callEocActive();
        }
    }, [profile, woy])

    return (
        // <ThemeProvider theme={customTheme}>
        <Paper sx={{
            // backgroundColor: 'red',
            width: '100%',
            paddingBottom: '10px',
            paddingLeft: '20px',
            paddingRight: '20px'
        }}>
            <Typography sx={{
                height: '50px',
                lineHeight: '50px',
                fontSize: 24
            }}>
                {`สถานะการดำเนินการ${areaName}`}
            </Typography>
            <Grid container>
                {
                    profile.org_level !== "01" ?
                        <>
                            <Grid item xs={6}>
                                <Typography sx={{
                                    color: "#1151a4",
                                    fontSize: 14
                                }}>เข้าเกณฑ์เปิด EOC</Typography>
                                <Typography sx={{
                                    color: "#1151a4",
                                    fontSize: 28
                                }}>{
                                    !loadFinish ? "-" : 
                                        qualifyEOC ? "เข้าเกณฑ์" : "ไม่เข้าเกณฑ์"
                                    }
                                </Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography sx={{
                                    color: "#cd6c4a",
                                    textAlign: 'right',
                                    fontSize: 14
                                }}>เปิด EOC</Typography>
                                <Typography sx={{
                                    color: "#cd6c4a",
                                    textAlign: 'right',
                                    fontSize: 28
                                }}>{
                                    !loadFinish ? "-" : 
                                        openEOC ? "เปิด" : "ไม่เปิด"
                                    }
                                </Typography>
                            </Grid>
                        </> : <>
                            <Grid item xs={6}>
                                <Typography sx={{
                                    color: "#cd6c4a",
                                    fontSize: 14
                                }}>เปิด EOC</Typography>
                                <Typography sx={{
                                    color: "#cd6c4a",
                                    fontSize: 28
                                }}>{
                                    !loadFinish ? "-" : 
                                        openEOC ? "เปิด" : "ไม่เปิด"
                                    }
                                </Typography>
                            </Grid>
                        </>
                }
            </Grid>
            {/* <PieChart
                series={[
                    {
                        // data: [
                        //     { id: 0, value: 10, label: 'ประชุม EOC', },
                        //     { id: 1, value: 15, label: 'สำรวจลูกน้ำยุงลาย' },
                        //     { id: 2, value: 20, label: 'ลงพื้นที่พ่นยา' },
                        // ]
                        data: activityList
                    },
                ]}
                slotProps={{
                    noDataOverlay: {
                        message: 'ไม่มีการจัดกิจกรรมใดๆ',

                    },
                    legend: {
                        direction: 'row',
                        position: { vertical: 'bottom', horizontal: 'middle' },
                        // padding: '50px 0px 0px 0px',

                    },
                    popper: {
                        // content: (<Typography>Test</Typography>)
                        // component: <Typography>Test</Typography>
                        // sx: {
                        //     com
                        // }
                    }
                }}

                // xAxis={{
                //     valueFormatter: (code, context) => {
                //         if (context.location === 'tick') {
                //             return `${code}`;
                //         } else {
                //             return `สัปดาห์ที่ ${code}`
                //         }
                //     },
                // }}
                // width={500}
                // width={"100%"}
                height={250}
                margin={{
                    top: 10, right: 10, left: 25, bottom: 50
                }}
                sx={(theme) => ({

                })}
            /> */}
            <BarChart
                borderRadius={5}
                dataset={activityList}
                xAxis={[{ 
                    scaleType: 'band', 
                    label: "ประเภทกิจกรรม",
                    dataKey: "type",
                }]}
                yAxis={[{ 
                    max: 10,
                    label: 'จำนวนการจัดกิจกรรม',
                }]}
                series={[{
                    dataKey: 'count',
                    label: 'จำนวน',
                    valueFormatter: (value) => {
                        return `${value} ครั้ง`
                    }
                }]}
                height={300}
                slotProps={{
                    noDataOverlay: {
                        message: 'ไม่มีการจัดกิจกรรมใดๆ',
                    },
                    legend: {hidden: true}
                }}
            />
            {/* <BarChart
                borderRadius={5}
                dataset={dataSet}
                xAxis={[{
                    scaleType: 'band',
                    dataKey: 'week',
                    valueFormatter: (code, context) => {
                        if (context.location === 'tick') {
                            return `${code}`;
                        } else {
                            return `สัปดาห์ที่ ${code}`
                        }
                    },
                    barGapRatio: 0
                }]}
                yAxis={[{ disableLine: true, disableTicks: true, valueFormatter: valueFormatterY }]}
                series={[
                    { dataKey: 'qualify', label: "เข้าเกณฑ์", color: '#1151a4', },
                    { dataKey: 'open', label: "เปิด EOC",color: '#cd6c4a'},
                    // { dataKey: 'newYork', valueFormatter },
                    // { dataKey: 'seoul', valueFormatter },
                ]}
                slotProps={{
                    legend: {hidden: true}
                }}
                height={200}
                sx={{
                    [`.${axisClasses.left} .${axisClasses.label}`]: {
                        transform: 'translate(-20px, 0)',
                    },
                }}
                margin={{
                    left: 20,
                    top: 10,
                    right: 20,
                    bottom: 30
                }}
            /> */}
        </Paper>
    )
}

export default DashboardEocSummary
